const race = [
  "American Indian or Alaska Native",
  "Asian",
  "Black or African American",
  "Hispanic, Latino, or Spanish",
  "Native Hawaiian or Others",
  "White or Caucasian",
  "Other or not listed",
];

const sex = [
  { name: "Male", value: "male", id: 1 },
  { name: "Female", value: "female", id: 2 },
  { name: "I prefer not to say", value: "prefer_not_to_say", id: 3 },
];

const counts = {
  One: 1,
  Two: 2,
  Three: 3,
  Four: 4,
  Five: 5,
  Six: 6,
  Seven: 7,
  Eight: 8,
  Nine: 9,
  Ten: 10,
  Eleven: 11,
  Twelve: 12,
};
export const screenNames = {
  ACCOUNT: 0,
  PROFILE: 1,
  SHIPPING: 2,
  LOGIN: 3,
  CONFIRMATION: 4,
};
const screenIndex = [
  { key: screenNames.ACCOUNT, open: true },
  { key: screenNames.PROFILE, open: false },
  { key: screenNames.SHIPPING, open: false },
  { key: screenNames.LOGIN, open: false },
  { key: screenNames.CONFIRMATION, open: false },
];

export { race, sex, counts, screenIndex };

export const USER_PROGRESS_STEPS = {
  ACCOUNT_CREATION: "AccountCreation",
  SETTING_PROFILE: "SetupProfile",
};

export const EXISTING_USER_STEPS_PROFILE = [
  "Log In",
  "Profile Setup",
  "Shipping Information",
  "Download App",
];
export const EXISTING_USER_STEPS_SHIPPING = [
  "Log In",
  "Shipping Information",
  "Download App",
];

export const stepper_text = {
  LOG_IN: "Log In",
  ENROLMENT: "Enrollment",
  SHIPPING: "Shipping Information",
  CONFIRMATION: "Download App",
};

//Steps for the user to follow after account creation
export const STEPS_AFTER_ENROLLMENT = [
  "Download the KardiaComplete App and log in with your email and password created during enrollment.",
  "You will receive an email confirming when your devices have shipped.",
  "Start exploring what your KardiaComplete membership has to offer.",
];

//Steps for the user to follow after program enrollment
export const STEPS_AFTER_PROGRAM_ENROLLMENT = [
  "Download the Kardia App and log in with the email and password created you just created.",
  "You will receive an email confirming when your devices have shipped.",
  "Start exploring what your program has to offer."
];

export const PLAY_STORE_LINK =
  "https://play.google.com/store/apps/details?id=com.alivecor.aliveecg.simba&pli=1";
export const APP_STORE_LINK =
  "https://apps.apple.com/us/app/kardiacomplete/id1611446187";


export const ENROLLMENT_STEPS_NUMBER = {
  ELIGIBILITY_CHECK: 0,
  ELIGIBILITY_SUCCESS: 1,
  CARE_PATHWAY_TREAT: 2,
  CARE_PATHWAY_PREVENT: 3,
  PROGRAM_RESULT: 4,
  CREATE_ACCOUNT: 5,
  SHIPPING_ADDRESS: 6,
  SUCCESS: 7,
}

export const ENROLLMENT_ERROR_PAGE = {
  DEFAULT: 'DEFAULT_ERROR_PAGE',
  UNDER_AGE: 'UNDER_AGE_ERROR_PAGE',
  API_ERROR: 'API_ERROR',
};
